<template>
  <div v-if="!accessToken" id="g_id_onload"
    :data-client_id="googleClientId"
    data-context="signin"
    data-callback="googleLoginCallback"
    data-auto_select="true"
  >
  </div>
</template>
<script setup lang="ts">
const runtimeConfig = useRuntimeConfig()
const googleClientId: string = runtimeConfig.public.googleClientId

const accessToken = ref(useUserInfo().value?.accessToken)
</script>
<style lang='scss' scoped>
</style>